import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { RoutePath } from '../enum/common-enum';

export const registerGuard: CanActivateFn = (route, state) => {
  const storageService = inject(StorageService);
  const router = inject(Router);
  const url = state.url;
  const registerId = storageService.retrieve('REGISTER_ID');
  const allowedPaths = ['/subscription', '/registration-List', '/messagify-user'];
  const restrictedPaths: any = [RoutePath.WhatsappCampaign, RoutePath.WhatsappReport, RoutePath.Inbox];

  if (allowedPaths.some(path => url.startsWith(path))) {
    return true;
  }

  if (restrictedPaths.some(path => url.startsWith(path))) {
    router.navigateByUrl('/subscription');
    return false;
  }

  if (registerId) {
    router.navigateByUrl('/subscription');
    return false;
  }

  return true;
};
